import { render, staticRenderFns } from "./waterLevelTwo.vue?vue&type=template&id=dbc7b42a&scoped=true&"
import script from "./waterLevelTwo.vue?vue&type=script&lang=js&"
export * from "./waterLevelTwo.vue?vue&type=script&lang=js&"
import style0 from "./waterLevelTwo.vue?vue&type=style&index=0&id=dbc7b42a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc7b42a",
  null
  
)

export default component.exports